<template>
  <div id="SCPanel-wrapper" class="panel-hidden">
    <slot></slot>
    <!-- <slot name="burn-state"></slot> -->
    <div id="toggle-SCPanel-button" @click="toggleSCPanel">
      <svg
        id="toggle-SCPanel-icon"
        xmlns="http://www.w3.org/2000/svg"
        height="28px"
        viewBox="0 0 24 24"
        width="28px"
        fill="#FFFFFF"
        style="display: block; margin: auto"
      >
        <path d="M24 24H0V0h24v24z" fill="none" opacity="1" />
        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
      </svg>
    </div>
  </div>
</template>

<script>
import './SpacecraftPanel.scss'
export default {
  name: 'SpacecraftPanel',
  props: ['updateStyle', 'toggleSCPanel', 'hideSCPanel'],
  mounted() {
    this.updateStyle('#FirstViewer')
    this.hideSCPanel()
  },
  methods: {}
}
</script>

<style scoped></style>
